import React from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import TrackOrderContainer from '../components/TrackOrderContainer/TrackOrderContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'

function TrackOrder() {
  return (
    <>
    <NavbarContainer/>
    <Container>
      <Row>
        <Col md={3}>
        <AccountSidebar/>

        </Col>
        <Col md={9}>
<TrackOrderContainer/>
        </Col>
      </Row>
    </Container>
    <Footer/>
    </>
      )
}

export default TrackOrder